import {useEffect} from "react"

export const useHideFooterUntilLastPage = (hideFooterUntilLastPage: boolean, hasNextPage: boolean) => {
    useEffect(() => {
        if (!hideFooterUntilLastPage) {
            return
        }

        const footerElement = document.querySelector<HTMLDivElement>("#next-footer-entrypoint .App")

        if (!footerElement) {
            return
        }

        footerElement.style.display = hasNextPage ? "none" : "block"
    }, [hideFooterUntilLastPage, hasNextPage])
}
